<template>
<div id="">
  <v-container fluid class="pt-0 ">
    <v-row>
      <v-col cols="12" class="pt-0 ">
        <v-card class="admin_secondary">
          <v-card-title class="secondary white--text">
            Email Notification Templates
            <v-spacer></v-spacer>
            <v-btn icon dark @click="load" :loading="loading">
              <v-icon>fa-sync</v-icon>
            </v-btn>
          </v-card-title>

          <v-container class="">
            <v-row align="center">
              <v-col cols="12" md="4" lg="3" xl="2">
                <v-text-field v-model="search" append-icon="fa-search" dark label="Search" outlined hide-details clearable></v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="3" xl="2">
                <v-select outlined hide-details clearable dark label="Filter Group" placeholder="All" :items="filters" v-model="filter"></v-select>
              </v-col>
              <v-col cols="12" md="4" lg="3" xl="2">
                <v-switch label="Active Only" v-model="show_active_only" dark color="green"></v-switch>
              </v-col>
            </v-row>

            <v-data-table show-expand :loading="loading" :headers="headers" :items="items" :search="search">

              <template v-slot:item.active="{ item }">
                <v-icon v-if="item.active===1" color="green" small>fa-circle</v-icon>
                <v-icon v-else color="grey" small>far fa-circle</v-icon>
                  </template>


              <template v-slot:item.action="{ item }">
                    <v-btn icon small color="primary"><v-icon small>fa-edit</v-icon></v-btn>
                  </template>

              <template v-slot:expanded-item="{ headers,item }">
                       <td :colspan="headers.length" class="pa-0">
                         <email-template v-model="item"></email-template>
                       </td>
                     </template>

            </v-data-table>

          </v-container>

        </v-card>

      </v-col>
    </v-row>
  </v-container>

</div>
</template>
<script>
import headersEmail from "./headers_email.json";
import emailTemplate from "./email_template"

export default {
  name: "",
  components: {
    emailTemplate
  },
  data: () => ({
    search: '',
    show_active_only: false,
    filter: '',
    filters: ['Business', 'General', 'Profile', 'Project', 'Project-Contest', 'Wallet'],
    loading: false,
    modified: false,
    templates: []
  }),
  watch: {
    'templates': {
      handler: function() {
        this.modified = true
      },
      deep: true
    }
  },
  computed: {
    headers() {
      return headersEmail
    },
    items() {
      return this.templates.filter(function(i) {
        if (this.show_active_only) {
          if (i.active === 0) {
            return false
          }
        }
        if (this.filter) {
          if (i.group === this.filter) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      }.bind(this))
    }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true;
      this.templates = await this.$api(`/account/admin/email-notification-templates`)
      setTimeout(function() {
        this.modified = false
      }.bind(this), 100)
      this.loading = false;
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
